import AppManagementRequest from './AppManagementRequest';

export default class ExtensionTypeRequest extends AppManagementRequest {
	//param @app : AppManagementModel
	//param @createdBy: user profile from useIdentify()
	//param @extension: Extension (defined in ./AppManagementModel.js)
	constructor(app, createdBy, extension, requirementNumber) {
		super(app, createdBy, requirementNumber);

		this.extension = extension;
	}
}
